import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { color } from "chart.js/helpers";
import { clone, cloneDeep } from "lodash";
import { ConfigurationModel } from "../models/configuration";
import { ColorOfType, ColorSettings, UserSettingsDTO } from "../models/UserSettings";
import { ConfigurationService } from "./configuration.service";
import { EndpointsService } from "./endpoints.service";
import { ModalConfirmationService } from "./modal-confirmation.service";
import { PointsService } from "./points.service";
import { UserSettingsService } from "./userSettings.service";

@Injectable({
  providedIn: 'root'
})
export class ConfigurationColorService{

colorOfTypesChange: ColorSettings;
static defaultColorTypes: ColorOfType[] = [new ColorOfType("Navaids","All Navaids","", ''),
new ColorOfType("Navaids","DME","Published", ''),
new ColorOfType("Navaids","DME","User Defined", ''),
new ColorOfType("Navaids","VOR_DME","Published", ''),
new ColorOfType("Navaids","VOR_DME","User Defined", ''),
new ColorOfType("Navaids","TACAN","Published", ''),
new ColorOfType("Navaids","TACAN","User Defined", ''),
new ColorOfType("Navaids","VORTAC","Published", ''),
new ColorOfType("Navaids","VORTAC","User Defined", ''),
new ColorOfType("Navaids","DME_ILS","Published", ''),
new ColorOfType("Navaids","DME_ILS","User Defined", ''),
new ColorOfType("Navaids","NDB","Published", ''),
new ColorOfType("Navaids","NDB","User Defined", ''),
new ColorOfType("Navaids","VOR","Published", ''),
new ColorOfType("Navaids","VOR","User Defined", ''),

new ColorOfType("CoordinatePoints","All Coordinate Points","",''),
new ColorOfType("CoordinatePoints","Waypoint","Published",''),
new ColorOfType("CoordinatePoints","Waypoint","User Defined",''),
new ColorOfType("CoordinatePoints","ARP_Civil","Published",''),
new ColorOfType("CoordinatePoints","ARP_Civil","User Defined",''),
new ColorOfType("CoordinatePoints","ARP_Militar","Published",''),
new ColorOfType("CoordinatePoints","ARP_Militar","User Defined",''),
new ColorOfType("CoordinatePoints","ARP_Mixed","Published",''),
new ColorOfType("CoordinatePoints","ARP_Mixed","User Defined",''),
new ColorOfType("CoordinatePoints","RWY_THR","Published",''),
new ColorOfType("CoordinatePoints","RWY_THR","User Defined",''),
new ColorOfType("CoordinatePoints","Airspace_Vertex","Published",''),
new ColorOfType("CoordinatePoints","Airspace_Vertex","User Defined",''),
new ColorOfType("CoordinatePoints","Fix_Point","Published",''),
new ColorOfType("CoordinatePoints","Fix_Point","User Defined",''),
new ColorOfType("Air_Space_Boundary","Airspace","",'#ff0000')
];
  constructor(
    public userSettingsService: UserSettingsService,
    public http: HttpClient,
    public endPointService: EndpointsService,
    public configurationService: ConfigurationService
    ){
  }
  initialize(){
    this.colorOfTypesChange = cloneDeep(this.userSettingsService.userSettings.colorSettings);
  }
  getColorNavaids(){
    return Object.entries(this.colorOfTypesChange.navaidColors);
  }
  getColorCP(){
    return Object.entries(this.colorOfTypesChange.coordinatePointColors);
  }
  getColorAirspace(){
    return Object.entries(this.colorOfTypesChange.airspaceColor);
  }

  cancel(){
    this.colorOfTypesChange = cloneDeep(this.userSettingsService.userSettings.colorSettings);
  }
}

